document.addEventListener("DOMContentLoaded", async function () {
  if (window.location.pathname === "/pages/findway-wholesale") {
    $(".fww-loading").removeClass("hidden");
    const customerInfoDiv = document.getElementById("fww-cus-info");
    if (customerInfoDiv === null) {
      window.location.href = "https://findway-canada.myshopify.com/pages/become-a-partner";
    }
    const logoLink = document.querySelector('.theme__logo a');
    if (logoLink) {
      logoLink.href = window.location.href;
    }

    const cusCredSn = customerInfoDiv.dataset.cusCred;
    const cusMake = customerInfoDiv.dataset.cusMake;
    const cusCategory = customerInfoDiv.dataset.cusCategory;
    const cusDownload = customerInfoDiv.dataset.cusDownload;
    
    if (!customerInfoDiv) {
      console.log("Invalid Customer.");
      return;
    } else {
      if (!cusCredSn) {
        console.log("No Customer Cred.");
      } else {
        const result = await checkCusCred(cusCredSn, cusMake, cusCategory);
        await fwwinitializeDropdowns(result, cusMake, cusCategory);
        const { tableHtml } = result;
        renderWholesaleTable(tableHtml, cusDownload);
      }
    }

    const hasSeenMainTour = localStorage.getItem('Fww-wsDriverObj') === 'true';

    // localStorage.removeItem("Fww-wsDriverObj");
    // localStorage.removeItem("Fww-cartDriver");

  if (!hasSeenMainTour) {
    const wsdriver = window.driver.js.driver;
    const wsdriverObj = wsdriver({
      popoverClass: 'fww-driverjs-theme',
      overlayColor: 'black',
      showButtons: [
        'next',
        'previous'
      ],
      showProgress: true,
      allowClose: false,
      steps: [
        {
          element: "#fww-viewBtn",
          popover: {
            title: "Toggle Price Column",
            description: "Click the eye icon to display the Price column. Click it again to hide the column. By default, the Price column is hidden.",
            side: "bottom",
            align: 'center'
          }
        },
        {
          element: ".fww-selection-form",
          popover: {
            title: "Product Search",
            description: "The product search feature allows users to select one or more options from the Category, Make, and Model drop-downs, then click Search to retrieve the matching results.",
            onPrevClick: () => {
              document.querySelector('#fww-selection-colls-button')?.click();
              wsdriverObj.movePrevious();
            },
            side: "bottom",
            align: 'center'
          },
          onDeselected: () => {
            document.querySelector('#fww-selection-colls-button')?.click();
          }
        },
        {
          element: "#fww-selection-colls",
          popover: {
            title: "Category Drop-down",
            description: "If the partner has preselected default Categories and Makes on the application form, the product table will display only the products that match those selections. Otherwise, all products are shown by default.",
            onPrevClick: () => {
              document.querySelector('#fww-selection-colls-button')?.click();
              wsdriverObj.movePrevious();
            },
            onNextClick: () => {
              document.querySelector('#fww-selection-colls-button')?.click();
              wsdriverObj.moveNext();
            },
            side: "bottom",
            align: 'center'
          }
        },
        {
          element: "#fww-pts-galleryId",
          popover: {
            title: "Product Image Gallery",
            description: "Click the image to open it in full-screen view. Certain products feature an expanded gallery with multiple images.",
            onPrevClick: () => {
              document.querySelector('#fww-selection-colls-button')?.click();
              wsdriverObj.movePrevious();
            },
            side: "bottom",
            align: 'center'
          }
        },
        {
          element: "#fww-note",
          popover: {
            title: "Note",
            description: "Products with the same SKU share the same inventory.",
            side: "top",
            align: 'center'
          }
        },
        {
          element: "#fww-pagination-container",
          popover: {
            title: "Page Navigation",
            description: "Click the ‹ › arrows or any page number to switch pages.",
            side: "top",
            align: 'center'
          }
        },
        { 
          popover: { 
            title: 'Try Adding an Item to Your Cart', 
            description: 'An in-cart guide will walk you through how the discount is applied. Please give it a try now.',
            onNextClick: () => {
              localStorage.setItem('Fww-wsDriverObj', 'true');
              wsdriverObj.destroy();
            },
          }
        }
      ]
    });
    
    wsdriverObj.drive();
  }
    
    const categorySelectAll = document.getElementById(
      "category-checkbox-item-1"
    );
    const categoryOptions = document.querySelectorAll(
      '#fww-selection-colls ul li input[type="checkbox"]:not(#category-checkbox-item-1)'
    );
    const makeSelectAll = document.getElementById("make-checkbox-item-1");
    const makeOptions = document.querySelectorAll(
      '#fww-selection-makes ul li input[type="checkbox"]:not(#make-checkbox-item-1)'
    );
    
    categoryOptions.forEach((option) => {
      option.addEventListener("change", async function () {
        clearModelDropdown();
        if (!this.checked) {
          const allUnChecked = Array.from(categoryOptions).every(
            (opt) => !opt.checked
          );
          if (allUnChecked) {
            categorySelectAll.checked = false;
            makeOptions.forEach((option) => {
              option.checked = false;
            });
            makeSelectAll.checked = false;
          } else {
            categorySelectAll.checked = false;
            await fwwinitializeModel(cusCredSn); 
          }
        } else if (this.checked) {
          const allChecked = Array.from(categoryOptions).every(
            (opt) => opt.checked
          );
          if (allChecked) {
            categorySelectAll.checked = true;
          }
          await fwwinitializeModel(cusCredSn);
        }
      });
    });
    categorySelectAll.addEventListener("change", async function () {
      clearModelDropdown();
      if (this.checked) {
        categoryOptions.forEach((option) => {
          option.checked = true;
        });
        await fwwinitializeModel(cusCredSn);
      } else if (!this.checked) {
        categoryOptions.forEach((option) => {
          option.checked = false;
        });
        makeOptions.forEach((option) => {
          option.checked = false;
        });
        makeSelectAll.checked = false;
      }
    });

    makeOptions.forEach((option) => {
      option.addEventListener("change", async function () {
        clearModelDropdown();
        if (!this.checked) {
          const allUnChecked = Array.from(makeOptions).every(
            (opt) => !opt.checked
          );
          if (allUnChecked) {
            makeSelectAll.checked = false;
          } else {
            makeSelectAll.checked = false;
            await fwwinitializeModel(cusCredSn);
          } 
        } else if (this.checked) {
          const allChecked = Array.from(makeOptions).every(
            (opt) => opt.checked
          );
          if (allChecked) {
            makeSelectAll.checked = true;
          }
          await fwwinitializeModel(cusCredSn);
        }
      });
    });

    makeSelectAll.addEventListener("change", async function () {
      clearModelDropdown();
      if (this.checked) {
        makeOptions.forEach((option) => {
          option.checked = true;
        });
        await fwwinitializeModel(cusCredSn);
      } else if (!this.checked) {
        makeOptions.forEach((option) => {
          option.checked = false;
        });
      }
    });

    const safeParseArray = (str) => {
      try {
        const parsed = JSON.parse(str);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    };

    const makeArray = safeParseArray(cusMake);
    const categoryArray = safeParseArray(cusCategory);
    if (makeArray.length > 0 || categoryArray.length > 0) {
      const modelSelectAll = document.getElementById("model-checkbox-item-1");
      const modelOptions = document.querySelectorAll('#fww-selection-models ul li input[type="checkbox"]:not(#model-checkbox-item-1)');
      modelOptions.forEach((option) => {
        option.addEventListener("change", function () {
          if (!this.checked) {
            modelSelectAll.checked = false;
            const allUnChecked = Array.from(modelOptions).every(
              (opt) => !opt.checked
            );
          } else {
            const allChecked = Array.from(modelOptions).every(
              (opt) => opt.checked
            );
            if (allChecked) {
              modelSelectAll.checked = true;
            }
          }
        });
      });
      modelSelectAll.addEventListener("change", function () {
        if (this.checked) {
          modelOptions.forEach((option) => {
            option.checked = true;
          });
        } else if (!this.checked) {
          modelOptions.forEach((option) => {
            option.checked = false;
          });
        }
      });
    }

    //Add to cart
    $('.fww-table-data').click(function(e) {
      if (e.target && e.target.classList.contains("fwws-quantity-control-down")) {
        const input = e.target.closest("div").querySelector("input[type='text']");
        let currentValue = parseInt(input.value, 10);
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
        //console.log(input.value);
      }

      if (e.target && e.target.classList.contains("fwws-quantity-control-up")) {
        const input = e.target.closest("div").querySelector("input[type='text']");
        let currentValue = parseInt(input.value, 10);
        input.value = currentValue + 1;
        //console.log(input.value);
      }

      if (e.target && (e.target.id === "fww-addtocart" || e.target.classList.contains("fww-addtocart"))) {
        e.preventDefault();
        const cartForm = e.target.closest(".fww-cart-form");
        if (cartForm) {
          const cartFormItemID = cartForm.dataset.itemId;
          const cartFormItemSku = cartForm.dataset.itemSku;
          const cartFormItemVinfo = cartForm.dataset.itemVinfo;
          const cartFormItemVopt = cartForm.dataset.itemVopt;

          let properties = {
            SKU: cartFormItemSku,
            "Vehicle Info": cartFormItemVinfo,
          };
          if (cartFormItemVopt && cartFormItemVopt !== "undefined") {
            properties["Vehicle Option"] = cartFormItemVopt;
          }

          const input = cartForm?.parentElement?.querySelector("input[type='text']");

          //console.log('addToCart: ', input.value);
          if (!input || !input.value) return;
          let formData = {
            items: [
              {
                id: cartFormItemID,
                quantity: input.value,
                properties: properties,
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }).then((response) => {
              return response.json().then((Data) => {
                if (Data.status === 422) {
                  Swal.fire({
                    icon: "warning",
                    title: "Quantity Exceeded",
                    text: Data.message,
                    allowOutsideClick: true,
                    iconColor: "red",
                    confirmButtonColor: "#3085D6",
                  });
                }
              });
            }).then((data) => {
                const input = cartForm?.parentElement?.querySelector("input[type='text']");
                if (!input || !input.value) return;
                input.value = 1;
                openMiniCartDrawer();
                const hasSeenCartTour = localStorage.getItem('Fww-cartDriver') === 'true';
                if (!hasSeenCartTour) {
                  setTimeout(() => {
                    startCartDrawerGuide();
                  }, 2000);
                }
              }).catch((error) => {
                if (error) {
                  console.error("Error:", error);
                }
              });
          }
        }
    });
  }
});

function startCartDrawerGuide () {
  const cartDriver = window.driver.js.driver({
    popoverClass: 'fww-driverjs-theme',
    overlayColor: 'black',
    showButtons: [
      'next',
      'previous'
    ],
    showProgress: true,
    allowClose: false,
    steps: [
      {
        element: '#fww-pv-discount',
        popover: {
          title: 'Discount Preview',
          description: 'The discount shown here is for preview purposes only. To apply the discount, please enter the wholesale discount code manually at checkout.',
          side: 'left',
          align: 'center'
        }
      },
      {
        element: '#checkout',
        popover: {
          title: 'Proceed to Checkout',
          description: "<img class='w-[270px] h-[202px]' src='https://cdn.shopify.com/s/files/1/0553/5760/3977/files/ezgif-42b1e66e766b55.gif?v=1750455437' /><span class='text-sm block mt-2.5 text-center'>Enter the promo code at checkout to apply the discount.</span>",
          side: 'left',
          align: 'center'
        }
      },
      {
        popover: {
          title: 'Thank you for your patience!',
          description: "We hope you have a pleasant experience.",
          onNextClick: () => {
            localStorage.setItem('Fww-cartDriver', 'true');
            cartDriver.destroy();
          },
        }
      }
    ]
  });
  cartDriver.drive();
}


async function fwwinitializeModel(cusCredSn) {
  const selectedOpts = await getSelectedOptions();
  if (selectedOpts.categories.length <= 0) {
    clearModelDropdown();
    return;
  }
  const { makes } = selectedOpts;
  if (makes && makes.length > 0) {
    await fwwinitializeModelDropdown(cusCredSn, selectedOpts);
    const modelSelectAll = document.getElementById(
      "model-checkbox-item-1"
    );
    const modelOptions = document.querySelectorAll(
      '#fww-selection-models ul li input[type="checkbox"]:not(#model-checkbox-item-1)'
    );
    modelOptions.forEach((option) => {
      option.addEventListener("change", function () {
        console.log('modelOptions Clicked');
        if (!this.checked) {
          modelSelectAll.checked = false;
          const allUnChecked = Array.from(modelOptions).every(
            (opt) => !opt.checked
          );
        } else {
          const allChecked = Array.from(modelOptions).every(
            (opt) => opt.checked
          );
          if (allChecked) {
            modelSelectAll.checked = true;
          }
        }
      });
    });
    modelSelectAll.addEventListener("change", function () {
      console.log('modelSelectAll Clicked');
      if (this.checked) {
        modelOptions.forEach((option) => {
          option.checked = true;
        });
      } else if (!this.checked) {
        modelOptions.forEach((option) => {
          option.checked = false;
        });
      }
    });
  }
}

async function fwwinitializeDropdowns(data, cusMake, cusCategory) {
  if (!data) {
    return;
  }
  //console.log(cusMake, cusCategory);

  const categoryDropdown = document.getElementById("fww-selection-colls");
  const makeDropdown = document.getElementById("fww-selection-makes");
  const modelDropdown = document.getElementById("fww-selection-models");
  const categoryUl = categoryDropdown.querySelector("ul");
  const makeUl = makeDropdown.querySelector("ul");
  const modelUl = modelDropdown.querySelector("ul");
  const modelSelectAll = document.getElementById("model-checkbox-item-1");

  const { collections, makes, models } = data;

  makes.sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
  collections.sort((a, b) => b.localeCompare(a, "en", { sensitivity: "base" }));
  models.sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));

  collections.forEach((collection, index) => {
    const liElem = document.createElement("li");
    liElem.className = "list-none";

    const optionDiv = document.createElement("div");
    optionDiv.className = "flex items-center p-2 rounded-sm hover:bg-gray-100";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className =
      "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
    checkbox.id = `category-checkbox-item-${index + 2}`;
    const categorySelectAll = document.getElementById(
      "category-checkbox-item-1"
    );
    checkbox.checked = cusCategory != 'null' ? cusCategory.includes(collection) : true;
    if (cusCategory == 'null') {
      categorySelectAll.checked = true;
    }

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.className = "w-full ms-2 text-sm font-medium text-gray-900";
    label.textContent = collection;

    optionDiv.appendChild(checkbox);
    optionDiv.appendChild(label);
    liElem.appendChild(optionDiv);
    categoryUl.appendChild(liElem);
  });

  makes.forEach((make, index) => {
    const liElem = document.createElement("li");
    liElem.className = "list-none";

    const optionDiv = document.createElement("div");
    optionDiv.className = "flex items-center p-2 rounded-sm hover:bg-gray-100";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className =
      "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
    checkbox.id = `make-checkbox-item-${index + 2}`;
    const makeSelectAll = document.getElementById("make-checkbox-item-1");
    checkbox.checked = cusMake != 'null' ? cusMake.includes(make) : true;
    if (cusMake == 'null') {
      makeSelectAll.checked = true;
    }

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.className = "w-full ms-2 text-sm font-medium text-gray-900";
    label.textContent = make;

    optionDiv.appendChild(checkbox);
    optionDiv.appendChild(label);
    liElem.appendChild(optionDiv);
    makeUl.appendChild(liElem);
  });
  models.forEach((model, index) => {
    const liElem = document.createElement("li");
    liElem.className = "list-none";

    const optionDiv = document.createElement("div");
    optionDiv.className = "flex items-center p-2 rounded-sm hover:bg-gray-100";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className =
      "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
    checkbox.id = `model-checkbox-item-1-${index + 2}`;
    checkbox.checked = true;

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.className = "w-full ms-2 text-sm font-medium text-gray-900";
    label.textContent = model;

    optionDiv.appendChild(checkbox);
    optionDiv.appendChild(label);
    liElem.appendChild(optionDiv);
    modelUl.appendChild(liElem);
  });
  if (models.length > 0) {
    modelSelectAll.checked = true;
  } else {
    modelSelectAll.checked = false;
  }
  
}

async function getSelectedOptions() {
  const categoryCheckboxes = document.querySelectorAll(
    '#fww-selection-colls ul li input[type="checkbox"]'
  );
  const selectedCategories = [];
  categoryCheckboxes.forEach((checkbox) => {
    if (checkbox.checked && checkbox.id !== "category-checkbox-item-1") {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      if (label) {
        selectedCategories.push(label.textContent.trim());
      }
    }
  });

  const makeCheckboxes = document.querySelectorAll(
    '#fww-selection-makes ul li input[type="checkbox"]'
  );
  const selectedMakes = [];
  makeCheckboxes.forEach((checkbox) => {
    if (checkbox.checked && checkbox.id !== "make-checkbox-item-1") {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      if (label) {
        selectedMakes.push(label.textContent.trim());
      }
    }
  });

  const modelCheckboxes = document.querySelectorAll(
    '#fww-selection-models ul li input[type="checkbox"]'
  );
  const selectedModels = [];
  modelCheckboxes.forEach((checkbox) => {
    if (checkbox.checked && checkbox.id !== "model-checkbox-item-1") {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      if (label) {
        selectedModels.push(label.textContent.trim());
      }
    }
  });
  //console.log(selectedCategories, selectedMakes, selectedModels);

  return {
    categories: selectedCategories,
    makes: selectedMakes,
    models: selectedModels,
  };
}

async function checkCusCred(cusCred, cusMake, cusCategory) {
  const selectedOpts = await getSelectedOptions();
  const payload = {
    signature: cusCred,
    cusmakes: cusMake,
    cuscategories: cusCategory,
    sopts: selectedOpts,
    method: "first",
  };
  try {
    const response = await fetch(
      "https://ybseoaist6ha7hxajveeqauaoe0oqsvr.lambda-url.ca-central-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    const result = await response.json();
    //console.log(result);
    return result;
  } catch (error) {
    console.error("Error sending request to server:", error);
  }
}

let fwwPdfRows = [];

function makeWholesalePdf () {
  if (!fwwPdfRows.length) { 
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Sorry, no data is currently loaded. Please try again."
    });
    return; 
  }

  const header = ['#', 'Collection', 'Coverage', 'Make', 'Year', 'Model', 'Option', 'Note', 'SKU', 'Price'];
  
  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [40, 40, 40, 40],
    content: [
      { text: 'Findway Products Catalogue for Wholesale', style: 'header', margin: [0, 0, 0, 10] },
      { text: 'Prices are subject to change without notice, the prevailing price on our website at the time of transaction shall apply.', style: 'subtitle', margin: [0, 0, 0, 10] },
      {
        table: {
          headerRows: 1,
          widths: [30, '*', 80, 50, 35, 70, 90, 80, 60, 70],
          body: [
            header.map(h => ({ text: h, bold: true })),
            ...fwwPdfRows
          ]
        },
        layout: 'lightHorizontalLines'
      }
    ],
    styles: { header: { fontSize: 18, bold: true } }
  };

  pdfMake.createPdf(docDefinition).download('wholesale-list.pdf');
}

$('#fww-dl-pdf').click(function() {
  makeWholesalePdf();
});

function renderWholesaleTable(results, cusDownload) {
  if (results.length > 0) {
  const parseYear = (yearString) => {
    try {
      const years = JSON.parse(yearString);
      return Array.isArray(years) ? years[0] : 0;
    } catch {
      return 0;
    }
  };

  results.sort((a, b) => {
    const makeA = a.Make ? a.Make.toUpperCase() : "";
    const makeB = b.Make ? b.Make.toUpperCase() : "";
    const modelA = a.Model ? a.Model.toUpperCase() : "";
    const modelB = b.Model ? b.Model.toUpperCase() : "";
    const yearA = parseYear(a.Year);
    const yearB = parseYear(b.Year);
    if (makeA < makeB) return -1;
    if (makeA > makeB) return 1;
    if (modelA < modelB) return -1;
    if (modelA > modelB) return 1;
    if (yearA < yearB) return -1;
    if (yearA > yearB) return 1;
    return 0;
  });
  
  fwwPdfRows = [];
  if (cusDownload === 'true') {
    let globalIdx = 0;
    results.forEach(item => {
      if (item.ProductStatus != "Looking For Vehicle" && item.ProductStatus != "Developing") {
        let years = [];
        if (item.Year) {
          const cleaned = item.Year.replace(/[\[\]]/g, '');
          years = cleaned.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n)).sort((a,b)=>a-b);
        }
        const yearRange = years.length
          ? (years[0] === years.at(-1) ? `${years[0]}` : `${years[0]}-${years.at(-1)}`)
          : '';
        item.Variants.forEach(variant => {
          globalIdx++;
          fwwPdfRows.push([
            String(globalIdx),
            item.CollectionName || '',
            item.Coverage && item.Coverage !== 'undefined' ? item.Coverage : '',
            item.Make || '',
            yearRange,
            item.Model || '',
            item.Option && item.Option !== 'undefined' ? item.Option.replace(/[\[\]"]/g, '') : '',
            item.FitNote && item.FitNote !== 'undefined' ? item.FitNote.replace(/[\[\]"]/g, '') : '',
            variant.VariantSKU || '',
            variant.VariantPrice || ''
          ]);
        });
      }
    });
  }
  
  const itemsPerPage = 10;
  $('#fww-pagination-container').pagination({
    dataSource: results,
    pageSize: itemsPerPage,
    hideOnlyOnePage: true,
    className: 'paginationjs-big',
    callback: function(data, pagination) {
      let html = "";
      let count = (pagination.pageNumber - 1) * itemsPerPage;
      let optCnt = 0.5;
      data.forEach((item) => {
          let years = [];
          if (item.Year) {
            const cleanedYearString = item.Year.replace(/[\[\]]/g, '');
            years = cleanedYearString.split(",").map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
          }
          years.sort((a, b) => a - b);
          const minYear = years.length > 0 ? years[0] : "";
          const maxYear = years.length > 0 ? years[years.length - 1] : "";

          item.Variants.forEach((variant) => {
            count++;
            optCnt++;

            html += `<div class="flex flex-col bg-[#f2f2f2] text-center rounded-xl mt-4 lg:mt-2 sm:w-[95%] lg:w-full lg:flex-row lg:justify-between lg:items-center lg:h-fit">`;
              html += `<div class="select-none hidden p-3 text-gray-900 font-semibold lg:block lg:text-sm lg:content-center lg:h-full lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-0 lg:rounded-l-xl lg:min-w-11 lg:max-w-11">${count}</div>`;
            
              html += `<div class="select-none p-3 text-lg text-gray-900 font-bold lg:text-sm lg:font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-8">${item.CollectionName || ""}</div>`;

              html += `<div class="flex flex-row justify-center lg:items-center lg:h-full lg:justify-between">`;
                html += `<div id="fww-pts-galleryId" class="select-none p-3 w-2/5 lg:w-fit lg:content-center lg:h-full lg:min-w-28 lg:max-w-28 lg:bg-[#f2f2f2]">`;
                  if (item.ProductImgs && Array.isArray(item.ProductImgs)) {
                    let galleryId = count;
                    item.ProductImgs.forEach((img, idx) => {
                      if (idx === 0) {
                        html += `<a href="${img}" class="glightbox" data-gallery="gallery-${galleryId}"><img class="rounded-xl lg:w-20 w-28" src="${img}" /></a>`;
                      } else {
                        html += `<a href="${img}" class="glightbox hidden" data-gallery="gallery-${galleryId}"><img class="lg:w-20 w-28 rounded-xl" src="${img}" /></a>`;
                      }
                    });
                  }
                html += `</div>`;

                html += `<div class="flex flex-col p-3 w-3/5 items-start lg:flex-row lg:order-first lg:items-center lg:p-0 lg:h-full lg:w-full">`;
                  html += `<div class="flex flex-row flex-wrap gap-1 mb-1 lg:flex-nowrap lg:items-center lg:gap-0 lg:mb-0 lg:h-full lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-[22rem]">`;
                    html += `<div class="select-none text-base text-gray-900 font-semibold lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-16 lg:max-w-16">${minYear && maxYear ? (minYear === maxYear ? `${minYear}` : `${minYear} - ${maxYear}`) : ""}</div>`;
                    html += `<div class="select-none text-base text-gray-900 font-semibold lg:order-first lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24">${item.Make || ""}</div>`;
                    html += `<div class="select-none text-base text-gray-900 font-semibold lg:order-first lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24">${item.Model || ""}</div>`;
                  html += `</div>`;

              if (item.Option && item.Option !== "undefined") {
                html += `<div class="select-none hidden lg:block p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:overflow-auto lg:bg-[#f2f2f2]">${item.Option.trim()}</div>`;
              } else {
                html += `<div class="hidden lg:block select-none p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:bg-[#f2f2f2]"></div>`;
              }

              if (item.OptionImage && item.OptionImage !== "undefined") {
                html += `<img tabindex="0" onkeydown="if (event.key === 'Enter') { this.click(); event.preventDefault(); }" class="w-2/5 h-2/5 p-3 hidden lg:block rounded-3xl cursor-pointer sm:h-fit lg:min-w-28 lg:max-w-28 lg:h-auto glightbox" data-gallery="gallery-${optCnt++}" src="${item.OptionImage}">`;
              } else {
                html += `<div class="hidden lg:block lg:w-2/5 lg:h-2/5 lg:p-3 lg:min-w-28 lg:max-w-28 lg:h-auto"></div>`;
              }
            
                  if (item.FitNote && item.FitNote !== "undefined") {
                    const notesArray = JSON.parse(item.FitNote);
                    const cleaned = notesArray.join('. '); 
                    html += `<div class="select-none lg:hidden block text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:overflow-auto lg:bg-[#f2f2f2]">${cleaned}</div>`;
                  } else {
                    html += `<div class="lg:hidden block select-none text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:bg-[#f2f2f2]"></div>`;
                  }

                  if (item.Coverage && item.Coverage !== "undefined") {
                    html += `<div class="select-none text-sm text-left text-gray-900 font-semibold mb-1 lg:order-first lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-40 lg:max-w-40 lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-48">${item.Coverage}</div>`;
                  } else {
                    html += `<div class="hidden lg:block select-none text-sm text-left text-gray-900 font-semibold mb-1 lg:order-first lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-40 lg:max-w-40 lg:bg-[#f2f2f2]">${" "}</div>`;
                  }
            
                  html += `<div class="select-none text-sm text-gray-900 font-semibold lg:order-1 lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24 lg:bg-[#f2f2f2]"><span class="lg:hidden">SKU: </span>${variant.VariantSKU ? variant.VariantSKU : ""}</div>`;
                  
                  html += `<div class="select-none lg:hidden block price-cell text-sm text-gray-900 font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:min-w-20 lg:max-w-20 lg:bg-[#f2f2f2]">${variant.VariantPrice || ""}</div>`;
                  
                html += `</div>`;
              html += `</div>`;

              html += `<hr class="bg-gray-400 mt-0 lg:hidden">`;
            
              if (item.Option && item.Option !== "undefined") {
                html += `<div class="select-none block lg:hidden p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:overflow-auto lg:bg-[#f2f2f2]">${item.Option.trim()}</div>`;
              } else {
                html += `<div class="block lg:hidden select-none p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:bg-[#f2f2f2]"></div>`;
              }
          
              html += `<div class="flex flex-row justify-center lg:items-center lg:h-full lg:bg-[#f2f2f2] lg:rounded-r-xl">`;
                if (item.OptionImage && item.OptionImage !== "undefined") {
                  html += `<img tabindex="0" onkeydown="if (event.key === 'Enter') { this.click(); event.preventDefault(); }" class="block lg:hidden w-2/5 h-2/5 p-3 rounded-3xl cursor-pointer sm:h-fit lg:min-w-28 lg:max-w-28 lg:h-auto glightbox" data-gallery="gallery-${optCnt++}" src="${item.OptionImage}">`;
                } else {
                  html += `<div class="block lg:hidden lg:w-2/5 lg:h-2/5 lg:p-3 lg:min-w-28 lg:max-w-28 lg:h-auto"></div>`;
                }

                if (item.FitNote && item.FitNote !== "undefined") {
                  const notesArray = JSON.parse(item.FitNote);
                  const cleaned = notesArray.join('. '); 
                  html += `<div class="select-none hidden lg:block text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:overflow-auto lg:bg-[#f2f2f2]">${cleaned}</div>`;
                } else {
                  html += `<div class="hidden lg:block select-none text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:bg-[#f2f2f2]"></div>`;
                }
            
                html += `<div class="select-none hidden lg:block price-cell text-sm text-gray-900 font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:min-w-20 lg:max-w-20 lg:bg-[#f2f2f2]">${variant.VariantPrice || ""}</div>`;
                
                html += `<div class="flex flex-col justify-center p-3 w-full lg:h-full lg:min-w-52 lg:max-w-52">`;
                  html += `<div class="flex flex-row gap-2 items-center justify-between lg:justify-center mb-4 lg:mb-2 min-[400px]:gap-4 sm:gap-2">`;
                    html += `<button class="fwws-quantity-control-down w-[30%] mb-0 bg-gray-400 block lg:hidden" type="button">-</button>`;
                    html += `<input class="fww-cart-form-input justify-items-center lg:!h-7 lg:!leading-7 !mb-0 !w-2/5 lg:!w-4/6 !rounded-none !border-2 !border-[#c5c5c5] !indent-0" type="text" min="1" name="quantity" value="1" placeholder="1">`;
                    html += `<button class="fwws-quantity-control-up w-[30%] mb-0 bg-gray-400 block lg:hidden" type="button">+</button>`;
                  html += `</div>`;
                  html += `<div class="fww-cart-form w-full" data-item-id="${variant.VariantID.split("/").pop()}" data-item-sku="${variant.VariantSKU}" data-item-vinfo="${minYear && maxYear ? (minYear === maxYear ? `${minYear}` : `${minYear} - ${maxYear}`) : ""} ${item.Make} ${item.Model}" data-item-vopt="${item.Option}">`;
                    if (variant.VariantAvailableForSale === "true") {
                      html += `<input id="fww-addtocart" type="submit" name="button" class="!text-sm !px-0 !mb-0 lg:!h-8 lg:!leading-8 !w-full !rounded-lg lg:!w-4/6 !border-0" value="Add" />`;
                    } else {
                      if (item.ProductStatus !== "undefined" && item.ProductStatus !== "Developed" && item.ProductStatus !== "Looking For Vehicle") {
                        html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="${item.ProductStatus}" />`;
                      } else if (item.ProductStatus === "Looking For Vehicle") {
                        html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="Seek & Scan" />`;
                      } else {
                        html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="Sold Out" />`;
                      }
                    }
                  html += `</div>`;
                html += `</div>`;
              html += `</div>`;
            
            html += `</div>`;
          
            // html += `<div class="flex flex-col bg-[#f2f2f2] text-center rounded-xl mt-4 lg:mt-2 sm:w-[95%] lg:w-full lg:flex-row lg:justify-between lg:items-center lg:h-fit">`;
            //   html += `<div class="select-none hidden p-3 text-gray-900 font-semibold lg:block lg:text-sm lg:content-center lg:h-full lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-0 lg:rounded-l-xl lg:min-w-11 lg:max-w-11">${count}</div>`;
            
            //   html += `<div class="select-none p-3 text-lg text-gray-900 font-bold lg:text-sm lg:font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-8">${item.CollectionName || ""}</div>`;

            //   html += `<div class="flex flex-row justify-center lg:items-center lg:h-full lg:justify-between">`;
            //     html += `<div id="fww-pts-galleryId" class="select-none p-3 w-2/5 lg:w-fit lg:content-center lg:h-full lg:min-w-28 lg:max-w-28 lg:bg-[#f2f2f2]">`;
            //       if (item.ProductImgs && Array.isArray(item.ProductImgs)) {
            //         let galleryId = count;
            //         item.ProductImgs.forEach((img, idx) => {
            //           if (idx === 0) {
            //             html += `<a href="${img}" class="glightbox" data-gallery="gallery-${galleryId}"><img class="rounded-xl w-20" src="${img}" /></a>`;
            //           } else {
            //             html += `<a href="${img}" class="glightbox hidden" data-gallery="gallery-${galleryId}"><img class="rounded-xl" src="${img}" /></a>`;
            //           }
            //         });
            //       }
            //     html += `</div>`;

            //     html += `<div class="flex flex-col p-3 w-3/5 items-start lg:flex-row lg:order-first lg:items-center lg:p-0 lg:h-full lg:w-full">`;
            //       html += `<div class="flex flex-row flex-wrap gap-1 mb-1 lg:flex-nowrap lg:items-center lg:gap-0 lg:mb-0 lg:h-full lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-[22rem]">`;
            //         html += `<div class="select-none text-base text-gray-900 font-semibold lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-16 lg:max-w-16">${minYear && maxYear ? (minYear === maxYear ? `${minYear}` : `${minYear} - ${maxYear}`) : ""}</div>`;
            //         html += `<div class="select-none text-base text-gray-900 font-semibold lg:order-first lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24">${item.Make || ""}</div>`;
            //         html += `<div class="select-none text-base text-gray-900 font-semibold lg:order-first lg:text-sm lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24">${item.Model || ""}</div>`;
            //       html += `</div>`;
            
            //       if (item.FitNote && item.FitNote !== "undefined") {
            //         const notesArray = JSON.parse(item.FitNote);
            //         const cleaned = notesArray.join('. '); 
            //         html += `<div class="select-none text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:overflow-auto lg:bg-[#f2f2f2]">${cleaned}</div>`;
            //       } else {
            //         html += `<div class="hidden lg:block select-none text-sm text-rose-600 text-left font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-28 lg:max-w-28 lg:bg-[#f2f2f2]"></div>`;
            //       }

            //       if (item.Coverage && item.Coverage !== "undefined") {
            //         html += `<div class="select-none text-sm text-left text-gray-900 font-semibold mb-1 lg:order-first lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-40 lg:max-w-40 lg:sticky lg:bg-[#f2f2f2] lg:z-10 lg:left-48">${item.Coverage}</div>`;
            //       } else {
            //         html += `<div class="hidden lg:block select-none text-sm text-left text-gray-900 font-semibold mb-1 lg:order-first lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:text-center lg:min-w-40 lg:max-w-40 lg:bg-[#f2f2f2]">${" "}</div>`;
            //       }
            
            //       html += `<div class="select-none text-sm text-gray-900 font-semibold lg:order-1 lg:p-3 lg:content-center lg:h-full lg:min-w-24 lg:max-w-24 lg:bg-[#f2f2f2]"><span class="lg:hidden">SKU: </span>${variant.VariantSKU ? variant.VariantSKU : ""}</div>`;
                  
            //       html += `<div class="select-none price-cell text-sm text-gray-900 font-semibold mb-1 lg:p-3 lg:mb-0 lg:content-center lg:h-full lg:min-w-20 lg:max-w-20 lg:bg-[#f2f2f2]">${variant.VariantPrice || ""}</div>`;
                  
            //     html += `</div>`;
            //   html += `</div>`;

            //   html += `<hr class="bg-gray-400 mt-0 lg:hidden">`;
            
            //   if (item.Option && item.Option !== "undefined") {
            //     html += `<div class="select-none p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:overflow-auto lg:bg-[#f2f2f2]">${item.Option.trim()}</div>`;
            //   } else {
            //     html += `<div class="hidden lg:block select-none p-3 text-sm text-gray-900 font-semibold lg:content-center lg:h-full lg:min-w-40 lg:max-w-40 lg:bg-[#f2f2f2]"></div>`;
            //   }
          
            //   html += `<div class="flex flex-row justify-center lg:items-center lg:h-full lg:bg-[#f2f2f2] lg:rounded-r-xl">`;
            //     if (item.OptionImage && item.OptionImage !== "undefined") {
            //       html += `<img tabindex="0" onkeydown="if (event.key === 'Enter') { this.click(); event.preventDefault(); }" class="w-2/5 h-2/5 p-3 rounded-3xl cursor-pointer sm:h-fit lg:min-w-28 lg:max-w-28 lg:h-auto glightbox" data-gallery="gallery-${optCnt}" src="${item.OptionImage}">`;
            //     } else {
            //       html += `<div class="hidden lg:block lg:w-2/5 lg:h-2/5 lg:p-3 lg:min-w-28 lg:max-w-28 lg:h-auto"></div>`;
            //     }
          
            //     html += `<div class="flex flex-col justify-center p-3 w-full lg:h-full lg:min-w-52 lg:max-w-52">`;
            //       html += `<div class="flex flex-row gap-2 items-center justify-between lg:justify-center mb-4 lg:mb-2 min-[400px]:gap-4 sm:gap-2">`;
            //         html += `<button class="fwws-quantity-control-down w-[30%] mb-0 bg-gray-400 block lg:hidden" type="button">-</button>`;
            //         html += `<input class="fww-cart-form-input justify-items-center lg:!h-7 lg:!leading-7 !mb-0 !w-2/5 lg:!w-4/6 !rounded-none !border-2 !border-[#c5c5c5] !indent-0" type="text" min="1" name="quantity" value="1" placeholder="1">`;
            //         html += `<button class="fwws-quantity-control-up w-[30%] mb-0 bg-gray-400 block lg:hidden" type="button">+</button>`;
            //       html += `</div>`;
            //       html += `<div class="fww-cart-form w-full" data-item-id="${variant.VariantID.split("/").pop()}" data-item-sku="${variant.VariantSKU}" data-item-vinfo="${minYear && maxYear ? (minYear === maxYear ? `${minYear}` : `${minYear} - ${maxYear}`) : ""} ${item.Make} ${item.Model}" data-item-vopt="${item.Option}">`;
            //         if (variant.VariantAvailableForSale === "true") {
            //           html += `<input id="fww-addtocart" type="submit" name="button" class="!text-sm !px-0 !mb-0 lg:!h-8 lg:!leading-8 !w-full !rounded-lg lg:!w-4/6 !border-0" value="Add" />`;
            //         } else {
            //           if (item.ProductStatus !== "undefined" && item.ProductStatus !== "Developed" && item.ProductStatus !== "Looking For Vehicle") {
            //             html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="${item.ProductStatus}" />`;
            //           } else if (item.ProductStatus === "Looking For Vehicle") {
            //             html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="Seek & Scan" />`;
            //           } else {
            //             html += `<input disabled id="fww-addtocart" type="submit" name="button" class="!mb-0 !w-full lg:!w-4/6 !bg-gray-400 !text-black !px-0 lg:!h-8 lg:!leading-8 !text-sm !rounded-lg !border-0 !cursor-not-allowed" value="Sold Out" />`;
            //           }
            //         }
            //       html += `</div>`;
            //     html += `</div>`;
            //   html += `</div>`;
            
            // html += `</div>`;
        });
      });
      
      $('.fww-table-data').fadeOut(300, function() {
        $(".fww-loading").addClass("hidden");
        $('.fww-search-btn').text("Search");
        $(this).html(html).fadeIn(300, function() {
          const priceHidden = document.getElementById('fww-cus-info').getAttribute('data-hide-price') === 'true';
          document.querySelectorAll('.price-cell').forEach(cell => { cell.style.color = priceHidden ? '#f2f2f2' : '#000000'; });
          document.getElementById('th-price').style.color = priceHidden ? "#000000" : "#ffffff";
        });
        const lightbox = GLightbox({ touchNavigation: true });
      });
    }
  });
  } else {
    $('#fww-pagination-container').pagination('destroy');
    fwwPdfRows = [];
    let html = "";
    html += `<p class="m-16 text-black text-center">Sorry, no data is currently loaded. Please make sure you have selected correct options.</p>`;
    $('.fww-table-data').fadeOut(300, function() {
      $(".fww-loading").addClass("hidden");
      $('.fww-search-btn').text("Search");
      $(this).html(html).fadeIn();
    });
  }
}

function togglePriceView () {
  const hideIcon = document.getElementById('fww-hideView');
  const showIcon = document.getElementById('fww-showView');
  hideIcon.classList.toggle('hidden');
  hideIcon.classList.toggle('block');
  showIcon.classList.toggle('hidden');
  showIcon.classList.toggle('block');

  const priceFlagEl = document.querySelector('[data-hide-price]');
  const priceIsHidden = showIcon.classList.contains('hidden');
  priceFlagEl.setAttribute('data-hide-price', priceIsHidden ? 'true' : 'false');
  if (priceIsHidden) {
    document.querySelectorAll('.price-cell').forEach(cell => { cell.style.color = '#f2f2f2'; });
    document.getElementById('th-price').style.color = "#000000";
  } else {
    document.querySelectorAll('.price-cell').forEach(cell => { cell.style.color = '#000000'; });
    document.getElementById('th-price').style.color = "#ffffff";
  }
}

function openMiniCartDrawer() {
  setTimeout(() => {
    const cartButton = document.querySelector(".js-mini-cart-trigger");
    const isExpanded = cartButton.getAttribute("aria-expanded") === "true";
    if (!isExpanded) {
      $(".js-mini-cart-trigger").click();
    }
  }, 300);
}

async function searchFwWS() {
  $('.fww-search-btn').text("Searching...");
  const customerInfoDiv = document.getElementById("fww-cus-info");
  const cusCredSn = customerInfoDiv.dataset.cusCred;
  const cusDownloadsn = customerInfoDiv.dataset.cusDownload;
  const selectedOpts = await getSelectedOptions();
  const results = await filteredTable(cusCredSn, selectedOpts);
  const { tableHtml } = results;
  //console.log(tableHtml);
  renderWholesaleTable(tableHtml, cusDownloadsn);
}

async function filteredTable(cusCredSn, selectedOpts) {
  const payload = {
    signature: cusCredSn,
    sopts: selectedOpts,
    method: "search",
  };
  try {
    const response = await fetch(
      "https://ybseoaist6ha7hxajveeqauaoe0oqsvr.lambda-url.ca-central-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error sending request to server:", error);
  }
}

async function fwwinitializeModelDropdown(cusCredSn, selectedOpts) {
  const payload = {
    signature: cusCredSn,
    sopts: selectedOpts,
    method: "modelDd",
  };
  try {
    const response = await fetch(
      "https://ybseoaist6ha7hxajveeqauaoe0oqsvr.lambda-url.ca-central-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    const result = await response.json();
    const { modelList } = result;
    if (!modelList) {
      return;
    }

    const modelSelectAll = document.getElementById("model-checkbox-item-1");
    const modelDropdown = document.getElementById("fww-selection-models");
    const modelUl = modelDropdown.querySelector("ul");

    modelList.sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));

    modelList.forEach((model, index) => {
      const liElem = document.createElement("li");
      liElem.className = "list-none";

      const optionDiv = document.createElement("div");
      optionDiv.className =
        "flex items-center p-2 rounded-sm hover:bg-gray-100";

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className =
        "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
      checkbox.id = `model-checkbox-item-${index + 2}`;
      checkbox.checked = true;

      const label = document.createElement("label");
      label.htmlFor = checkbox.id;
      label.className = "w-full ms-2 text-sm font-medium text-gray-900";
      label.textContent = model;

      optionDiv.appendChild(checkbox);
      optionDiv.appendChild(label);
      liElem.appendChild(optionDiv);
      modelUl.appendChild(liElem);
    });
    if (modelList.length > 0) {
      modelSelectAll.checked = true;
    }
  } catch (error) {
    console.error("Error sending request to server:", error);
  }
}

function clearModelDropdown() {
  const modelDropdownUl = document.querySelector("#fww-selection-models ul");
  if (modelDropdownUl) {
    modelDropdownUl.innerHTML = "";
    modelDropdownUl.innerHTML = `
      <li class="list-none">
        <div class="flex items-center p-2 rounded-sm hover:bg-gray-100">
          <input id="model-checkbox-item-1" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm">
          <label for="model-checkbox-item-1" class="w-full ms-2 text-sm font-medium text-gray-900 rounded-sm">Select All</label>
        </div>
      </li>
    `;
  }
}

// function clearMakeDropdown() {
//   const makeDropdownUl = document.querySelector("#fww-selection-makes ul");
//   if (makeDropdownUl) {
//     makeDropdownUl.innerHTML = "";
//     makeDropdownUl.innerHTML = `
//       <li class="list-none">
//         <div class="flex items-center p-2 rounded-sm hover:bg-gray-100">
//           <input id="make-checkbox-item-1" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm">
//           <label for="make-checkbox-item-1" class="w-full ms-2 text-sm font-medium text-gray-900 rounded-sm">Select All</label>
//         </div>
//       </li>
//     `;
//   }
// }

//////////////////////////////////
// html += `<div class="flex flex-row gap-2 items-center justify-between mb-4 min-[400px]:gap-4 sm:gap-2">`;
//                     html += `<button class="fwws-quantity-control-down w-[30%] mb-0 bg-gray-700" type="button">-</button>`;
//                     html += `<input class="fww-cart-form-input justify-items-center !mb-0 !w-2/5 !rounded-none !border-2 !indent-0" type="text" min="1" name="quantity" value="1" placeholder="1">`;
//                     html += `<button class="fwws-quantity-control-up w-[30%] mb-0 bg-gray-700" type="button">+</button>`;
//                   html += `</div>`;


// document.addEventListener("DOMContentLoaded", async function () {
//   if (window.location.pathname === "/pages/findway-wholesale") {
//     $('.footer-sect a[href="/pages/returns"]').parent().remove();
//     $('.footer-sect a[href="/pages/order-history-findway-canada"]').parent().remove();
//     $('.footer-sect a[href="/pages/installation-instruction"]').parent().remove();
//     $('.footer-sect a[href="/pages/shipping-info"]').parent().remove();
//     $(".fww-loading").removeClass("hidden");
//     const customerInfoDiv = document.getElementById("fww-cus-info");
//     const cusCredSn = customerInfoDiv.dataset.cusCred;
//     const cusPrice = customerInfoDiv.dataset.cusPrice;
//     const cusMake = customerInfoDiv.dataset.cusMake;
    
//     if (!customerInfoDiv) {
//       console.log("Invalid Customer.");
//       return;
//     } else {
//       if (!cusCredSn) {
//         console.log("No Customer Cred.");
//       } else {
//         const result = await checkCusCred(cusCredSn, cusPrice, cusMake);
//         await fwwinitializeDropdowns(result);
//         const { tableHtml } = result;
//         const { showPrice } = result;
//         renderWholesaleTable(tableHtml, showPrice);
//       }
//     }
    
//     const categorySelectAll = document.getElementById(
//       "category-checkbox-item-1"
//     );
//     const categoryOptions = document.querySelectorAll(
//       '#fww-selection-colls ul li input[type="checkbox"]:not(#category-checkbox-item-1)'
//     );
//     categoryOptions.forEach((option) => {
//       option.addEventListener("change", async function () {
//         clearModelDropdown();
//         await fwwinitializeModel(cusCredSn);
        
//         if (this.checked) {
//           categorySelectAll.checked = false;
//         } else if (!this.checked) {
//           const allUnchecked = Array.from(categoryOptions).every(
//             (opt) => !opt.checked
//           );
//           if (allUnchecked) {
//             categorySelectAll.checked = true;
//           }
//         }
//       });
//     });
//     categorySelectAll.addEventListener("change", async function () {
//       if (this.checked) {
//         categoryOptions.forEach((option) => {
//           option.checked = false;
//         });
//         clearModelDropdown();
//         await fwwinitializeModel(cusCredSn);
//       }
//     });
    
//     const makeSelectAll = document.getElementById("make-checkbox-item-1");
//     const makeOptions = document.querySelectorAll(
//       '#fww-selection-makes ul li input[type="checkbox"]:not(#make-checkbox-item-1)'
//     );

//     makeOptions.forEach((option) => {
//       option.addEventListener("change", async function () {
//         clearModelDropdown();
//         await fwwinitializeModel(cusCredSn);

//         if (this.checked) {
//           makeSelectAll.checked = false;
//         } else if (!this.checked) {
//           const allUnchecked = Array.from(makeOptions).every(
//             (opt) => !opt.checked
//           );
//           if (allUnchecked) {
//             makeSelectAll.checked = true;
//           }
//         }
//       });
//     });

//     makeSelectAll.addEventListener("change", function () {
//       if (this.checked) {
//         clearModelDropdown();
//         makeOptions.forEach((option) => {
//           option.checked = false;
//         });
//       }
//     });

//     //Add to cart
//     $('.fww-table-data').click(function(e) {
//       if (e.target && e.target.classList.contains("fwws-quantity-control-down")) {
//         const input = e.target.closest("div").querySelector("input[type='text']");
//         let currentValue = parseInt(input.value, 10);
//         if (currentValue > 1) {
//           input.value = currentValue - 1;
//         }
//         console.log(input.value);
//       }

//       if (e.target && e.target.classList.contains("fwws-quantity-control-up")) {
//         const input = e.target.closest("div").querySelector("input[type='text']");
//         let currentValue = parseInt(input.value, 10);
//         input.value = currentValue + 1;
//         console.log(input.value);
//       }

//       if (e.target && (e.target.id === "fww-addtocart" || e.target.classList.contains("fww-addtocart"))) {
//         e.preventDefault();
//         const cartForm = e.target.closest(".fww-cart-form");
//         if (cartForm) {
//           const cartFormItemID = cartForm.dataset.itemId;
//           const cartFormItemSku = cartForm.dataset.itemSku;
//           const cartFormItemVinfo = cartForm.dataset.itemVinfo;
//           const cartFormItemVopt = cartForm.dataset.itemVopt;

//           let properties = {
//             SKU: cartFormItemSku,
//             "Vehicle Info": cartFormItemVinfo,
//           };
//           if (cartFormItemVopt && cartFormItemVopt !== "undefined") {
//             properties["Vehicle Option"] = cartFormItemVopt;
//           }

//           const input = cartForm?.parentElement?.querySelector("input[type='text']");

//           console.log('addToCart: ', input.value);
//           if (!input || !input.value) return;
//           let formData = {
//             items: [
//               {
//                 id: cartFormItemID,
//                 quantity: input.value,
//                 properties: properties,
//               },
//             ],
//           };

//           fetch(window.Shopify.routes.root + "cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(formData),
//           }).then((response) => {
//               return response.json().then((Data) => {
//                 if (Data.status === 422) {
//                   Swal.fire({
//                     icon: "warning",
//                     title: "Quantity Exceeded",
//                     text: Data.message,
//                     allowOutsideClick: true,
//                     iconColor: "red",
//                     confirmButtonColor: "#3085D6",
//                   });
//                 }
//               });
//             }).then((data) => {
//                 const input = cartForm?.parentElement?.querySelector("input[type='text']");
//                 if (!input || !input.value) return;
//                 input.value = 1;
//                 openMiniCartDrawer();
//               }).catch((error) => {
//                 if (error) {
//                   console.error("Error:", error);
//                 }
//               });
//           }
//         }
//     });
//   }
// });

// async function fwwinitializeModel(cusCredSn) {
//   const selectedOpts = await getSelectedOptions();
//   const { makes } = selectedOpts;
//   if (makes && makes.length > 0) {
//     await fwwinitializeModelDropdown(cusCredSn, selectedOpts);
//     const modelSelectAll = document.getElementById(
//       "model-checkbox-item-1"
//     );
//     const modelOptions = document.querySelectorAll(
//       '#fww-selection-models ul li input[type="checkbox"]:not(#model-checkbox-item-1)'
//     );
//     modelOptions.forEach((option) => {
//       option.addEventListener("change", function () {
//         if (this.checked) {
//           modelSelectAll.checked = false;
//         }
//       });
//     });
//     modelSelectAll.addEventListener("change", function () {
//       if (this.checked) {
//         modelOptions.forEach((option) => {
//           option.checked = false;
//         });
//       }
//     });
//   }
// }

// async function fwwinitializeDropdowns(data) {
//   if (!data) {
//     return;
//   }

//   const categoryDropdown = document.getElementById("fww-selection-colls");
//   const makeDropdown = document.getElementById("fww-selection-makes");
//   const categoryUl = categoryDropdown.querySelector("ul");
//   const makeUl = makeDropdown.querySelector("ul");

//   const { collections, makes } = data;

//   makes.sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
//   collections.sort((a, b) => b.localeCompare(a, "en", { sensitivity: "base" }));

//   collections.forEach((collection, index) => {
//     const liElem = document.createElement("li");
//     liElem.className = "list-none";

//     const optionDiv = document.createElement("div");
//     optionDiv.className = "flex items-center p-2 rounded-sm hover:bg-gray-100";

//     const checkbox = document.createElement("input");
//     checkbox.type = "checkbox";
//     checkbox.className =
//       "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
//     checkbox.id = `category-checkbox-item-${index + 2}`;

//     const label = document.createElement("label");
//     label.htmlFor = checkbox.id;
//     label.className = "w-full ms-2 text-sm font-medium text-gray-900";
//     label.textContent = collection;

//     optionDiv.appendChild(checkbox);
//     optionDiv.appendChild(label);
//     liElem.appendChild(optionDiv);
//     categoryUl.appendChild(liElem);
//   });

//   makes.forEach((make, index) => {
//     const liElem = document.createElement("li");
//     liElem.className = "list-none";

//     const optionDiv = document.createElement("div");
//     optionDiv.className = "flex items-center p-2 rounded-sm hover:bg-gray-100";

//     const checkbox = document.createElement("input");
//     checkbox.type = "checkbox";
//     checkbox.className =
//       "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm";
//     checkbox.id = `make-checkbox-item-${index + 2}`;

//     const label = document.createElement("label");
//     label.htmlFor = checkbox.id;
//     label.className = "w-full ms-2 text-sm font-medium text-gray-900";
//     label.textContent = make;

//     optionDiv.appendChild(checkbox);
//     optionDiv.appendChild(label);
//     liElem.appendChild(optionDiv);
//     makeUl.appendChild(liElem);
//   });
// }

// async function getSelectedOptions() {
//   const categoryCheckboxes = document.querySelectorAll(
//     '#fww-selection-colls ul li input[type="checkbox"]'
//   );
//   const selectedCategories = [];
//   categoryCheckboxes.forEach((checkbox) => {
//     if (checkbox.checked && checkbox.id !== "category-checkbox-item-1") {
//       const label = document.querySelector(`label[for="${checkbox.id}"]`);
//       if (label) {
//         selectedCategories.push(label.textContent.trim());
//       }
//     }
//   });

//   const makeCheckboxes = document.querySelectorAll(
//     '#fww-selection-makes ul li input[type="checkbox"]'
//   );
//   const selectedMakes = [];
//   makeCheckboxes.forEach((checkbox) => {
//     if (checkbox.checked && checkbox.id !== "make-checkbox-item-1") {
//       const label = document.querySelector(`label[for="${checkbox.id}"]`);
//       if (label) {
//         selectedMakes.push(label.textContent.trim());
//       }
//     }
//   });

//   const modelCheckboxes = document.querySelectorAll(
//     '#fww-selection-models ul li input[type="checkbox"]'
//   );
//   const selectedModels = [];
//   modelCheckboxes.forEach((checkbox) => {
//     if (checkbox.checked && checkbox.id !== "model-checkbox-item-1") {
//       const label = document.querySelector(`label[for="${checkbox.id}"]`);
//       if (label) {
//         selectedModels.push(label.textContent.trim());
//       }
//     }
//   });
//   console.log(
//     "getSelectedOptions: ",
//     selectedCategories,
//     " ",
//     selectedMakes,
//     " ",
//     selectedModels
//   );

//   return {
//     categories: selectedCategories,
//     makes: selectedMakes,
//     models: selectedModels,
//   };
// }